import {
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from "../../../../../helpers";

const displayCancelMessage = (status: string): void => {
  switch (status) {
    case "PROCESSING":
    case "INTEGRATION_CANCEL_REQUESTED":
      showWarningMessage(
        "O cancelamento está em processamento e pode levar até 10 minutos para concluir!",
      );
      break;
    case "FAILED":
    case "INTEGRATION_CANCEL_FAILED":
      showErrorMessage("Houve um erro ao tentar cancelar a nota");
      break;
    case "INTEGRATION_CANCELED":
      showSuccessMessage("Nota cancelada com Sucesso!");
      break;
    case "RECURRENCE":
      showSuccessMessage("Recorrência cancela com sucesso");
      break;
    default:
      showSuccessMessage("Nota cancelada com Sucesso!");
  }
};

export default displayCancelMessage;
